import React, { useState, useEffect, useContext } from 'react';
import { ReactElement, JSXElementConstructor, ReactFragment, ReactPortal } from 'react';
import { Table, Avatar, Divider } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import Tab from '@mui/material/Tab';
import { Box, Tabs } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import { AptosContext } from '../../context/aptosContext';

import Arco from '../../asset/icons/Arco.png';
import Aptos from '../../asset/icons/Aptos.png';

export default function Bills() {

  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  const [amount, setAmount] = useState(0);
  const [, setDepositOrBorrow] = useState(true);
  const [isApt, setIsApt] = useState(true);
  const [isLend, SetIsLend] = useState(false);

  const aptosContext = useContext(AptosContext)!;

  const aptPrice = aptosContext?.aptPrice;
  const borrow = (Number(aptosContext?.borrow_amount) * Number(aptPrice)) / 100000000;
  const lend = (Number(aptosContext?.lend_amount) * Number(aptPrice)) / 100000000;
  const aptMeBorrow = Number(aptosContext?.borrow_amount) / 100000000;
  const aptMeLend = Number(aptosContext?.lend_amount) / 100000000;

  useEffect(() => {
    if (lend) SetIsLend(true);
    else SetIsLend(false);
  }, [lend]);

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === 0 && (
          <Box sx={{ p: 2 }}>
            {
              <>
                <span className="font-bold text-base text-[#000] block mb-2">Deposit Rate</span>
                <div className="flex flex-row items-center space-x-6">
                  <div className="flex flex-row items-center space-x-2 bg-white shadow-md p-2 rounded-md">
                    <Avatar src={isApt ? Aptos : Arco} />
                    <div className="flex flex-col">
                      <span className="text-base font-bold">{'8%'}</span>
                      <span className="text-xs text-text-black font-medium">{`Supply apy`}</span>
                    </div>
                  </div>
                  <span>+</span>
                  <div className="flex flex-row items-center space-x-2 bg-white shadow-md p-2 rounded-md">
                    <Avatar src={isApt ? Aptos : Arco} />
                    <div className="flex flex-col">
                      <span className="text-base font-bold">{'3 %'}</span>
                      <span className="text-xs text-text-black font-medium">{`Mining apy`}</span>
                    </div>
                  </div>
                </div>
                <span className="font-bold text-base text-[#000] block mt-4 mb-2">Borrow Limit</span>
                <div className="flex flex-row items-center justify-between">
                  <span className="text-sm text-text-black">Borrow Limit</span>
                  <span className="text-sm text-text-black">Borrow Rate</span>
                </div>
                <Divider />
                <div className="flex flex-row items-center justify-between">
                  <span className="text-sm text-text-black">0 $</span>
                  <span className="text-sm text-text-black">0 %</span>
                </div>
                <button
                  className="bg-text-blur text-white text-xs font-semibold py-2 w-full mt-4 rounded-full"
                  onClick={() => {
                    isApt ? aptosContext.Deposit1(amount * 100000000) : aptosContext.Deposit2(amount * 1000000);
                    setOpen(false);
                  }}
                >
                  Deposit
                </button>
              </>
            }
          </Box>
        )}
        {value === 1 && (
          <Box sx={{ p: 2 }}>
            {
              <>
                <span className="font-bold text-base text-[#000] block mb-2">Deposit Rate</span>
                <div className="flex flex-row items-center space-x-6">
                  <div className="flex flex-row items-center space-x-2 bg-white shadow-md p-2 rounded-md">
                    <Avatar src={isApt ? Aptos : Arco} />
                    <div className="flex flex-col">
                      <span className="text-base font-bold">{'8%'}</span>
                      <span className="text-xs text-text-black font-medium">{`Supply apy`}</span>
                    </div>
                  </div>
                  <span>+</span>
                  <div className="flex flex-row items-center space-x-2 bg-white shadow-md p-2 rounded-md">
                    <Avatar src={isApt ? Aptos : Arco} />
                    <div className="flex flex-col">
                      <span className="text-base font-bold">{'3 %'}</span>
                      <span className="text-xs text-text-black font-medium">{`Mining apy`}</span>
                    </div>
                  </div>
                </div>
                <span className="font-bold text-base text-[#000] block mt-4 mb-2">Borrow Limit</span>
                <div className="flex flex-row items-center justify-between">
                  <span className="text-sm text-text-black">Borrow Limit</span>
                  <span className="text-sm text-text-black">Borrow Rate</span>
                </div>
                <Divider />
                <div className="flex flex-row items-center justify-between">
                  <span className="text-sm text-text-black">0 $</span>
                  <span className="text-sm text-text-black">0 %</span>
                </div>
                <button
                  className="bg-text-blur text-white text-xs font-semibold py-2 w-full mt-4 rounded-full"
                  onClick={() => {
                    isApt ? aptosContext.Borrow1(amount * 100000000) : aptosContext.Borrow2(amount * 1000000);
                    setOpen(false);
                  }}
                >
                  Borrow
                </button>
              </>
            }
          </Box>
        )}
      </div>
    );
  }

  interface DataType {
    Asset: Object;
    Deposited: Object;
    Borrowed: Object;
  }

  const columns: ColumnsType<DataType> = isLend
    ? [
      {
        title: 'Asset',
        dataIndex: 'Asset',
        key: 'Asset',
        render: (item: {
          avatar:
          | string
          | number
          | boolean
          | ReactElement<any, string | JSXElementConstructor<any>>
          | ReactFragment
          | ReactPortal
          | null
          | undefined;
          name:
          | string
          | number
          | boolean
          | ReactElement<any, string | JSXElementConstructor<any>>
          | ReactFragment
          | ReactPortal
          | null
          | undefined;
          UR: any;
        }) => (
          <div className="flex w-full flex-row items-center space-x-4">
            <Avatar src={item.avatar} />
            <div className="flex flex-col">
              <span className="text-base font-bold">{item.name}</span>
              <span className="text-xs text-text-black font-medium">{`UR:${item.UR}%`}</span>
            </div>
          </div>
        ),
      },
      {
        title: 'Deposited',
        dataIndex: 'Deposited',
        key: 'Deposited',
        render: (item: { main: any; sub: any }) => (
          <div className="flex flex-col">
            <span className="text-base font-semibold">{`${item.main}`}</span>
            <span className="text-xs text-text-black font-medium">{`=$${item.sub}`}</span>
          </div>
        ),
      },
      {
        title: 'Borrowed',
        dataIndex: 'Borrowed',
        key: 'Borrowed',
        render: (item: { main: any; sub: any }) => (
          <div className="flex flex-col">
            <span className="text-base font-semibold">{`${item.main}`}</span>
            <span className="text-xs text-text-black font-medium">{`=$${item.sub}`}</span>
          </div>
        ),
      },
      {
        title: 'Operation',
        dataIndex: 'Operation',
        key: 'Operation',
        render: (item: { deposit_func: any; withdraw_func: any }) => (
          <div className="flex flex-row items-center justify-center space-x-2">
            <button
              onClick={item.deposit_func}
              className="bg-text-blur text-white text-xs font-semibold py-2 w-16 rounded-full"
            >
              Deposit
            </button>
            <button
              onClick={item.withdraw_func}
              className="bg-text-blur bg-opacity-25 text-text-blur text-xs font-semibold py-2 w-16 rounded-full"
            >
              Borrow
            </button>
          </div>
        ),
        align: 'center',
      },
    ]
    : [
      {
        title: 'Asset',
        dataIndex: 'Asset',
        key: 'name',
        render: (
          text:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | React.ReactFragment
            | React.ReactPortal
            | null
            | undefined
        ) => <span>{text}</span>,
      },
      {
        title: 'Deposited',
        dataIndex: 'Deposited',
        key: 'Deposited',
        render: (
          text:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | React.ReactFragment
            | React.ReactPortal
            | null
            | undefined
        ) => <span>{text}</span>,
      },
      {
        title: 'Borrowed',
        dataIndex: 'Borrowed',
        key: 'Borrowed',
        render: (
          text:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | React.ReactFragment
            | React.ReactPortal
            | null
            | undefined
        ) => <span>{text}</span>,
      },
      {
        title: 'Operation',
        dataIndex: 'Operation',
        key: 'Operation',
        render: (
          text:
            | string
            | number
            | boolean
            | React.ReactElement<any, string | React.JSXElementConstructor<any>>
            | React.ReactFragment
            | React.ReactPortal
            | null
            | undefined
        ) => <span>{text}</span>,
      },
    ];
  const Data = isLend
    ? [
      {
        Asset: {
          avatar: Aptos,
          name: 'APT',
          UR: '24.32',
        },
        Deposited: {
          main: aptMeLend,
          sub: lend,
        },
        Borrowed: {
          main: aptMeBorrow,
          sub: borrow,
        },
        Operation: {
          deposit_func: () => {
            handleClickOpen();
            setValue(0);
            setIsApt(true);
            setDepositOrBorrow(true);
            // aptosContext.Deposit1();
          },
          withdraw_func: () => {
            handleClickOpen();
            setValue(1);
            setIsApt(true);
            setDepositOrBorrow(false);
            // aptosContext.Borrow1();
          },
        },
      },
    ]
    : [];

  return (
    <div className="w-full">
      <span className="text-lg font-bold mb-10 w-full">My Bill</span>
      <div className="w-full rounded-md shadow-sm mt-6 flex flex-row items-center justify-center overflow-hidden">
        <Table columns={columns} dataSource={Data} style={{ width: '100%' }} pagination={false} />;
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="bg-text-blur">
          <span className="text-white block text-center mb-10">{isApt ? 'APT' : 'ARC'}</span>
          <div className="border-2 border-solid border-white rounded-md flex flex-row items-center justify-center space-x-2 px-2 py-1">
            <Avatar src={isApt ? Aptos : Arco} />
            <input
              type="number"
              step="any"
              value={amount}
              onChange={(e) => setAmount(parseFloat(e.target.value))}
              className="outline-none border-none text-white bg-[#0000] flex-1 text-base"
              placeholder="APT Amount"
            />
          </div>
        </DialogTitle>
        <DialogContent className="bg-background">
          <DialogContentText id="alert-dialog-description">
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  className="flex flex-row items-center"
                >
                  <Tab label="Deposit" {...a11yProps(0)} />
                  <Tab label="Borrow" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}></TabPanel>
              <TabPanel value={value} index={1}></TabPanel>
            </Box>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
